import React from 'react';
import {useSelector} from "react-redux";
import {productComponents, productsLoading} from "./productConfigSlice";
import {Spinner} from "@deere/ux.uxframe-react";
import {TextFilter, WtyReportTable} from "../common/wty-report-table/WtyReportTable";
import {languageResponseData} from "../Translation/translationSerachSlice";

const ComponentList = () => {

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
    };
    const prodComponents = useSelector(productComponents);
    const prodComponentsLoading = useSelector(productsLoading);

    const productComponentColumns = [
        {
            Header: translate('component1', 'Component'),
            accessor: 'componentLongDescription',
            Filter: TextFilter
        },
        {
            Header: translate('serial_number', 'Serial Number'),
            accessor: 'sNum',
            Filter: TextFilter
        }
    ];

    let productComponentList = [];

    if (prodComponents?.components && Object.entries(prodComponents?.components) && Object.entries(prodComponents?.components).length > 0) {
        productComponentList = Object.entries(prodComponents?.components)
            .map(([key, value]) => {
                const componentLongDescription = value.componentLongDescription;
                const sNum = value.serialNumbers[0].serialNumber;
                return (
                    {componentLongDescription, sNum}
                )
            })
    }

    return (
        <>
            {
                prodComponentsLoading ? (
                    <div className="uxf-spinner-border-inline mt-4">
                        <Spinner className="uxf-spinner-border-sm" animation="border"
                                 accessibilityLabel="Loading Product components"/>
                        <p aria-hidden="true" className="uxf-spinner-border-inline-text">
                            Loading Product components...
                        </p>
                    </div>
                ) : (
                    <>
                        {productComponentList && productComponentList.length > 0 ? (
                            <WtyReportTable columns={productComponentColumns} data={productComponentList}/>
                        ) : (
                            <span>{translate('message2','No Components found for the product.')}</span>
                        )}
                    </>
                )
            }

        </>
    );
};

export default ComponentList;